<script>
    import { accountRedbucks } from 'store/account'
    import { executeClient } from 'api/rage'

    export let SetPopup;
    export let searchText;

    let selectIndex = -1;

    let maxindex;

    let currentIndex = 0;

    const shopList = [
            {
                title: "Bugatti Divo",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/bdivo.png",
                price: 330000,
                line: "line4",
                list: [
                    {
                        model: "bdivo",
                        name: "Bugatti Divo",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/bdivo.png",
                        price: 330000,
                        line: "line4",
                    },
                ]
            },
            {
                title: "Bugatti Bolide",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/bolide.png",
                price: 330000,
                line: "line4",
                list: [
                    {
                        model: "bolide",
                        name: "Bugatti Bolide",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/bolide.png",
                        price: 330000,
                        line: "line4",
                    },
                ]
            },
            {
                title: "Bugatti Veyron",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/veyron.png",
                price: 330000,
                line: "line4",
                list: [
                    {
                        model: "veyron",
                        name: "Bugatti Veyron",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/veyron.png",
                        price: 330000,
                        line: "line4",
                    },
                ]
            },
            {
                title: "Bugatti Chiron",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/chiron19.png",
                price: 330000,
                line: "line4",
                list: [
                    {
                        model: "chiron19",
                        name: "Bugatti Chiron",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/chiron19.png",
                        price: 330000,
                        line: "line4",
                    },
                ]
            },
            {
                title: "UTOPIA",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/utopia.png",
                price: 300000,
                line: "line4",
                list: [
                    {
                        model: "utopia",
                        name: "UTOPIA",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/utopia.png",
                        price: 300000,
                        line: "line4",
                    },
                ]
            },
            {
                title: "Koenigsegg Gemera",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/gemera.png",
                price: 280000,
                line: "line4",
                list: [
                    {
                        model: "gemera",
                        name: "Koenigsegg Gemera",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/gemera.png",
                        price: 280000,
                        line: "line4",
                    },
                ]
            },
            {
                title: "Koenigsegg Jesko",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/jesko20.png",
                price: 280000,
                line: "line4",
                list: [
                    {
                        model: "jesko20",
                        name: "Koenigsegg Jesko",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/jesko20.png",
                        price: 280000,
                        line: "line4",
                    },
                ]
            },
            {
                title: "Koenigsegg CC850",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/cc850.png",
                price: 280000,
                line: "line4",
                list: [
                    {
                        model: "cc850",
                        name: "Koenigsegg CC850",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/cc850.png",
                        price: 280000,
                        line: "line4",
                    },
                ]
            },
            {
                title: "AGERA",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/agera.png",
                price: 280000,
                line: "line4",
                list: [
                    {
                        model: "agera",
                        name: "AGERA",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/agera.png",
                        price: 280000,
                        line: "line4",
                    },
                ]
            },
            {
                title: "REGERA",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/regera.png",
                price: 280000,
                line: "line4",
                list: [
                    {
                        model: "regera",
                        name: "REGERA",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/regera.png",
                        price: 280000,
                        line: "line4",
                    },
                ]
            },
            {
                title: "Ferrari FXX-K",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/fxxk.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "fxxk",
                        name: "Ferrari FXX-K",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/fxxk.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "SENNA",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/senna.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "senna",
                        name: "SENNA",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/senna.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "EVIJA",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/evija.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "evija",
                        name: "EVIJA",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/evija.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Lamborghini Essenza",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/essenza.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "essenza",
                        name: "Lamborghini Essenza",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/essenza.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "LAFERRARI",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/laferrari.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "laferrari",
                        name: "LAFERRARI",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/laferrari.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "RB001",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/rb001.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "rb001",
                        name: "RB001",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/rb001.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Ferrari Monza SP",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/monza.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "monza",
                        name: "Ferrari Monza SP",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/monza.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Porsche Mission R",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/missionr.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "missionr",
                        name: "Porsche Mission R",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/missionr.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "McLaren P1",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/mp1.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "mp1",
                        name: "McLaren P1",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/mp1.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "NEVERA",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/nevera.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "nevera",
                        name: "NEVERA",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/nevera.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "NOIRE",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/noire.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "noire",
                        name: "NOIRE",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/noire.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Lamborghini Vision GT",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/lamborghinivision.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "lamborghinivision",
                        name: "Lamborghini Vision GT",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/lamborghinivision.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "INVENCIBLE",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/invencible.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "invencible",
                        name: "INVENCIBLE",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/invencible.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "IDR",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/idr.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "idr",
                        name: "IDR",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/idr.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Cadillac Sixteen",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/sixteen.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "sixteen",
                        name: "Cadillac Sixteen",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/sixteen.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "McLaren Speedtail",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/speedtail.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "speedtail",
                        name: "McLaren Speedtail",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/speedtail.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Aston Martin Vulcan",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/vulcan.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "vulcan",
                        name: "Aston Martin Vulcan",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/vulcan.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "TUATARA",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/tuatara.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "tuatara",
                        name: "TUATARA",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/tuatara.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Mercedes-AMG ONE",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/amgone.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "amgone",
                        name: "Mercedes-AMG ONE",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/amgone.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "VALOUR",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/valour.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "valour",
                        name: "VALOUR",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/valour.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "BATTISTA",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/battista.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "battista",
                        name: "BATTISTA",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/battista.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "AMGF1",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/amgf1.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "amgf1",
                        name: "AMGF1",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/amgf1.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "D8",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/d8.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "d8",
                        name: "D8",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/d8.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Lamborghini Terzo",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/terzo.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "terzo",
                        name: "Lamborghini Terzo",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/terzo.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "918S",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/918s.png",
                price: 190000,
                line: "line3",
                list: [
                    {
                        model: "918s",
                        name: "918S",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/918s.png",
                        price: 190000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Lamborghini Veneno",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/veneno.png",
                price: 170000,
                line: "line3",
                list: [
                    {
                        model: "veneno",
                        name: "Lamborghini Veneno",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/veneno.png",
                        price: 170000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "ASVJ",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/asvj.png",
                price: 170000,
                line: "line3",
                list: [
                    {
                        model: "asvj",
                        name: "ASVJ",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/asvj.png",
                        price: 170000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "CENTENARIO",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/centenario.png",
                price: 170000,
                line: "line3",
                list: [
                    {
                        model: "centenario",
                        name: "CENTENARIO",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/centenario.png",
                        price: 170000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "REVENTON",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/reventon.png",
                price: 170000,
                line: "line3",
                list: [
                    {
                        model: "reventon",
                        name: "REVENTON",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/reventon.png",
                        price: 170000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "REVUELTO",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/revuelto.png",
                price: 170000,
                line: "line3",
                list: [
                    {
                        model: "revuelto",
                        name: "REVUELTO",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/revuelto.png",
                        price: 170000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "COUNTACH",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/countach.png",
                price: 170000,
                line: "line3",
                list: [
                    {
                        model: "countach",
                        name: "COUNTACH",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/countach.png",
                        price: 170000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "COUNTACH2",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/countach2.png",
                price: 170000,
                line: "line3",
                list: [
                    {
                        model: "countach2",
                        name: "COUNTACH2",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/countach2.png",
                        price: 170000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "SF90",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/sf90.png",
                price: 160000,
                line: "line3",
                list: [
                    {
                        model: "sf90",
                        name: "SF90",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/sf90.png",
                        price: 160000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "FERRARI812",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/ferrari812.png",
                price: 160000,
                line: "line3",
                list: [
                    {
                        model: "ferrari812",
                        name: "FERRARI812",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/ferrari812.png",
                        price: 160000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "F8",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/f8.png",
                price: 160000,
                line: "line3",
                list: [
                    {
                        model: "f8",
                        name: "F8",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/f8.png",
                        price: 160000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "F40",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/f40.png",
                price: 160000,
                line: "line3",
                list: [
                    {
                        model: "f40",
                        name: "F40",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/f40.png",
                        price: 160000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "GALLARDO",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/gallardo.png",
                price: 130000,
                line: "line3",
                list: [
                    {
                        model: "gallardo",
                        name: "GALLARDO",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/gallardo.png",
                        price: 130000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "LANZADOR",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/lanzador.png",
                price: 130000,
                line: "line3",
                list: [
                    {
                        model: "lanzador",
                        name: "LANZADOR",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/lanzador.png",
                        price: 130000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "DIABLO",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/diablo.png",
                price: 130000,
                line: "line3",
                list: [
                    {
                        model: "diablo",
                        name: "DIABLO",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/diablo.png",
                        price: 130000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "HURACAN",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/huracan.png",
                price: 130000,
                line: "line3",
                list: [
                    {
                        model: "huracan",
                        name: "HURACAN",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/huracan.png",
                        price: 130000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "HURACAN2",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/huracan2.png",
                price: 130000,
                line: "line3",
                list: [
                    {
                        model: "huracan2",
                        name: "HURACAN2",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/huracan2.png",
                        price: 130000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Mercedes V-Class",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/vclass.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "vclass",
                        name: "Mercedes V-Class",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/vclass.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "PUROSANGUE",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/purosangue.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "purosangue",
                        name: "PUROSANGUE",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/purosangue.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "TESTAROSSA",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/testarossa.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "testarossa",
                        name: "TESTAROSSA",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/testarossa.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "ROMA",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/roma.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "roma",
                        name: "ROMA",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/roma.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Porsche 911 Turbo",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/turbor.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "turbor",
                        name: "Porsche 911 Turbo",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/turbor.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Chevrolet Silverado",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/silverado.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "silverado",
                        name: "Chevrolet Silverado",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/silverado.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Shifter Kart",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/skart.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "skart",
                        name: "Shifter Kart",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/skart.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Snowmobile",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/snowmobile.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "snowmobile",
                        name: "Snowmobile",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/snowmobile.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Maserati MC20",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/mistral.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "mistral",
                        name: "Maserati MC20",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/mistral.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "MC20",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/mc20.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "mc20",
                        name: "MC20",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/mc20.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "McLaren 720S",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/720s.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "720s",
                        name: "McLaren 720S",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/720s.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "DAYTONA",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/daytona.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "daytona",
                        name: "DAYTONA",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/daytona.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Ferrari SF90 Imola",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/imola.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "imola",
                        name: "Ferrari SF90 Imola",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/imola.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "488PISTA",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/488pista.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "488pista",
                        name: "488PISTA",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/488pista.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Aston Martin DBX",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/dbx.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "dbx",
                        name: "Aston Martin DBX",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/dbx.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Hot Wheels",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/hotwheels.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "hotwheels",
                        name: "Hot Wheels",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/hotwheels.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "DeLorean DMC-12",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/delorean.png",
                price: 120000,
                line: "line3",
                list: [
                    {
                        model: "delorean",
                        name: "DeLorean DMC-12",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/delorean.png",
                        price: 120000,
                        line: "line3",
                    },
                ]
            },
            {
                title: "Nissan GT-R50",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/gtr50.png",
                price: 85000,
                line: "line2",
                list: [
                    {
                        model: "gtr50",
                        name: "Nissan GT-R50",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/gtr50.png",
                        price: 85000,
                        line: "line2",
                    },
                ]
            },
            {
                title: "Aston Martin DB5",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/db5.png",
                price: 85000,
                line: "line2",
                list: [
                    {
                        model: "db5",
                        name: "Aston Martin DB5",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/db5.png",
                        price: 85000,
                        line: "line2",
                    },
                ]
            },
            {
                title: "Ford GT",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/fordgt.png",
                price: 77500,
                line: "line2",
                list: [
                    {
                        model: "fordgt",
                        name: "Ford GT",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/fordgt.png",
                        price: 77500,
                        line: "line2",
                    },
                ]
            },
            {
                title: "Rolls-Royce Dawn",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/dawn.png",
                price: 77500,
                line: "line2",
                list: [
                    {
                        model: "dawn",
                        name: "Rolls-Royce Dawn",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/dawn.png",
                        price: 77500,
                        line: "line2",
                    },
                ]
            },
            {
                title: "Bentley Batur",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/batur.png",
                price: 55000,
                line: "line2",
                list: [
                    {
                        model: "batur",
                        name: "Bentley Batur",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/batur.png",
                        price: 55000,
                        line: "line2",
                    },
                ]
            },
            {
                title: "BENTAYGA2",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/bentayga2.png",
                price: 55000,
                line: "line2",
                list: [
                    {
                        model: "bentayga2",
                        name: "BENTAYGA2",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/bentayga2.png",
                        price: 55000,
                        line: "line2",
                    },
                ]
            },
            {
                title: "Maserati Levante",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/levante.png",
                price: 55000,
                line: "line2",
                list: [
                    {
                        model: "levante",
                        name: "Maserati Levante",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/levante.png",
                        price: 55000,
                        line: "line2",
                    },
                ]
            },
            {
                title: "Mercedes-AMG GT",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/amggt.png",
                price: 50000,
                line: "line2",
                list: [
                    {
                        model: "amggt",
                        name: "Mercedes-AMG GT",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/amggt.png",
                        price: 50000,
                        line: "line2",
                    },
                ]
            },
            {
                title: "Mercedes SLR",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/slr.png",
                price: 50000,
                line: "line2",
                list: [
                    {
                        model: "slr",
                        name: "Mercedes SLR",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/slr.png",
                        price: 50000,
                        line: "line2",
                    },
                ]
            },
            {
                title: "Mercedes E63S AMG",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/e63s.png",
                price: 50000,
                line: "line2",
                list: [
                    {
                        model: "e63s",
                        name: "Mercedes E63S AMG",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/e63s.png",
                        price: 50000,
                        line: "line2",
                    },
                ]
            },
            {
                title: "Mercedes G63 6x6",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/g63amg6x6.png",
                price: 32500,
                line: "line2",
                list: [
                    {
                        model: "g63amg6x6",
                        name: "Mercedes G63 6x6",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/g63amg6x6.png",
                        price: 32500,
                        line: "line2",
                    },
                ]
            },
            {
                title: "Hummer H1",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/hummer3.png",
                price: 30000,
                line: "line2",
                list: [
                    {
                        model: "hummer3",
                        name: "Hummer H1",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/hummer3.png",
                        price: 30000,
                        line: "line2",
                    },
                ]
            },
            {
                title: "Tesla Cybertruck",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/cybertruck.png",
                price: 30000,
                line: "line2",
                list: [
                    {
                        model: "cybertruck",
                        name: "Tesla Cybertruck",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/cybertruck.png",
                        price: 30000,
                        line: "line2",
                    },
                ]
            },
            {
                title: "BMW M5 E60",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/m5e60.png",
                price: 20000,
                line: "line1",
                list: [
                    {
                        model: "m5e60",
                        name: "BMW M5 E60",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/m5e60.png",
                        price: 20000,
                        line: "line1",
                    },
                ]
            },
            {
                title: "Toyota Supra A80",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/a80.png",
                price: 17500,
                line: "line1",
                list: [
                    {
                        model: "a80",
                        name: "Toyota Supra A80",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/a80.png",
                        price: 17500,
                        line: "line1",
                    },
                ]
            },
            {
                title: "Jaguar XK",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/xk.png",
                price: 17500,
                line: "line1",
                list: [
                    {
                        model: "xk",
                        name: "Jaguar XK",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/xk.png",
                        price: 17500,
                        line: "line1",
                    },
                ]
            },
            {
                title: "Mercedes EQS",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/eqs.png",
                price: 15000,
                line: "line1",
                list: [
                    {
                        model: "eqs",
                        name: "Mercedes EQS",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/eqs.png",
                        price: 15000,
                        line: "line1",
                    },
                ]
            },
            {
                title: "Mercedes X-Class",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/xclass2.png",
                price: 15000,
                line: "line1",
                list: [
                    {
                        model: "xclass2",
                        name: "Mercedes X-Class",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/xclass2.png",
                        price: 15000,
                        line: "line1",
                    },
                ]
            },
            {
                title: "Dodge Charger",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/charger2.png",
                price: 7000,
                line: "line1",
                list: [
                    {
                        model: "charger2",
                        name: "Dodge Charger",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/charger2.png",
                        price: 7000,
                        line: "line1",
                    },
                ]
            },
            {
                title: "Dodge Charger SRT",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/charger3.png",
                price: 7000,
                line: "line1",
                list: [
                    {
                        model: "charger3",
                        name: "Dodge Charger SRT",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/charger3.png",
                        price: 7000,
                        line: "line1",
                    },
                ]
            },
            {
                title: "Chevrolet Corvette",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/corvette2.png",
                price: 7000,
                line: "line1",
                list: [
                    {
                        model: "corvette2",
                        name: "Chevrolet Corvette",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/corvette2.png",
                        price: 7000,
                        line: "line1",
                    },
                ]
            },
            {
                title: "Ford Victoria",
                desc: "",
                function: "onSelectC",
                img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/victoria2.png",
                price: 500,
                line: "line1",
                list: [
                    {
                        model: "victoria2",
                        name: "Ford Victoria",
                        desc: "",
                        text: "Автомобиль",
                        img: "https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/victoria2.png",
                        price: 500,
                        line: "line1",
                    },
                ]
            }
    ];

    function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
    }

    let shuffledList = shuffle(shopList);
    let randomItems = shuffledList.slice(0, 4);

    const selected = (index, title) => {
        selectIndex = index;
        currentIndex = 0;
        maxindex = shopList[index].list.length - 1;
        switchBlock();
        window.pageloadf2 (1);
        window.pagenameitemf2 (title);
    }

    function switchBlock() {
    const blocks = document.querySelectorAll('.blgf');
    blocks.forEach((block, index) => {
        if (index === currentIndex) {
        block.style.display = 'flex';
        } else {
        block.style.display = 'none';
        }
    });
    }

    const nextBlock = () => {
        currentIndex = (currentIndex + 1);
        switchBlock();
    }

    const prevBlock = () => {
        currentIndex = (currentIndex - 1);
        switchBlock();
    }

    const onBuy = (item) => {
        if ($accountRedbucks < item.price)
            return window.notificationAdd(4, 9, `Недостаточно C-coins!`, 3000);
        SetPopup ()
        executeClient ("client::donate:buyCar", item.model);
        window.notificationAdd(3, 9, `Поздравляем с покупкой`, 3000);
    }

</script>
{#if selectIndex > -1}
    <div class="selectblockcl">
        {#each shopList[selectIndex].list as item, index}
        <div class="blgf" class:act={index === 0}>
            <div class="headsbcl">
                <h1>{item.name}</h1>
                <span>{item.price}
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1_40)">
                        <path d="M16.5 8.25C16.5 3.69365 12.8063 0 8.25 0C3.69365 0 0 3.69365 0 8.25C0 12.8063 3.69365 16.5 8.25 16.5C12.8063 16.5 16.5 12.8063 16.5 8.25Z" fill="#CFF80B"/>
                        <path d="M3.91016 10.5434C3.91016 10.4414 3.97818 10.3904 4.11416 10.3904C4.25013 10.3904 4.67088 10.484 5.37641 10.6709C5.53788 9.27691 5.99268 7.76394 6.74066 6.13194C7.00413 5.53696 7.31868 5.23944 7.68416 5.23944C7.75218 5.23944 7.81593 5.31166 7.87541 5.45619C7.94343 5.60071 7.97741 5.77921 7.97741 5.99169C7.97741 6.24669 7.84143 6.94794 7.56941 8.09544C7.30593 9.24294 7.13163 10.2417 7.04666 11.0917C7.60766 11.2192 8.10063 11.2829 8.52566 11.2829C8.95916 11.2829 9.35441 11.1725 9.71141 10.9514C10.0684 10.7219 10.3744 10.4287 10.6294 10.0717C11.1564 9.31516 11.4199 8.40571 11.4199 7.34319C11.4114 5.37969 10.6294 4.39794 9.07391 4.39794C8.52138 4.40641 7.54391 4.65294 6.14141 5.13744C5.86938 5.23096 5.63141 5.27769 5.42741 5.27769C5.22341 5.27769 5.12141 5.21821 5.12141 5.09919C5.12141 4.93771 5.24043 4.74646 5.47841 4.52544C5.71638 4.30441 6.02238 4.09194 6.39641 3.88794C7.31441 3.39494 8.20691 3.14844 9.07391 3.14844C10.2639 3.14844 11.2414 3.46719 12.0064 4.10469C12.9074 4.86121 13.3536 6.00871 13.3452 7.54719C13.3452 8.20171 13.2432 8.84769 13.0392 9.48519C12.8352 10.1227 12.5249 10.6922 12.1084 11.1937C11.6919 11.6867 11.1649 12.0862 10.5274 12.3922C9.88991 12.6982 9.13766 12.8512 8.27066 12.8512C7.92213 12.8512 7.48016 12.7747 6.94466 12.6217C6.88518 12.7832 6.73638 12.8639 6.49841 12.8639C6.05643 12.8639 5.75463 12.7917 5.59316 12.6472C5.44016 12.4942 5.35091 12.2477 5.32541 11.9077C4.91741 11.6782 4.57743 11.4402 4.30541 11.1937C4.04193 10.9472 3.91016 10.7304 3.91016 10.5434Z" fill="#1E1E1E" fill-opacity="0.5"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_1_40">
                        <rect width="16.5" height="16.5" fill="white"/>
                        </clipPath>
                        </defs>
                    </svg>                                    
                </span>
                <div class="btnbuy" on:keypress on:click={() => onBuy (item)}>Купить Автомобиль</div>
            </div>
            <div class="bgblocksbcl">
                <div class="linesbcl {item.line}"></div>
                <div class="centersbcl">
                    {#if currentIndex <= 0}
                        <span class="rligh" class:none={currentIndex <= 0}>
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="30" y="30" width="30" height="30" rx="15" transform="rotate(-180 30 30)" fill="#262626"/>
                                <path d="M18 10L11.4 15.5L18 21" stroke="white" stroke-opacity="0.5" stroke-linecap="round"/>
                            </svg> 
                        </span>
                        {:else}
                        <span class="rligh" class:none={currentIndex <= 0} on:keypress on:click={() => prevBlock ()}>
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="30" y="30" width="30" height="30" rx="15" transform="rotate(-180 30 30)" fill="#262626"/>
                                <path d="M18 10L11.4 15.5L18 21" stroke="white" stroke-opacity="0.5" stroke-linecap="round"/>
                            </svg> 
                        </span>
                    {/if}
                    <img src="{item.img}" onerror="this.onerror=null;this.src=this.src.replace('cdn-world.majestic-files.net/public/master/static/img/vehicles','cdn-ra3.ragemp.pro/cloud/inventoryItems/vehicle')" alt=""/>
                    {#if currentIndex === maxindex}
                        <span class="rligh" class:none={currentIndex === maxindex}>
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="30" height="30" rx="15" fill="#262626"/>
                                <path d="M12 20L18.6 14.5L12 9" stroke="white" stroke-opacity="0.5" stroke-linecap="round"/>
                            </svg>                                                                              
                        </span>
                        {:else}
                        <span class="rligh" class:none={currentIndex === maxindex} on:keypress on:click={() => nextBlock ()}>
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="30" height="30" rx="15" fill="#262626"/>
                                <path d="M12 20L18.6 14.5L12 9" stroke="white" stroke-opacity="0.5" stroke-linecap="round"/>
                            </svg>                                                                              
                        </span>
                    {/if}
                </div>
            </div>
        </div>
        {/each}
        <div class="catalogitems">
            <h1>Другие модели</h1>
            <div class="clilist">
                {#each randomItems as item, index} 
                    <div class="clotblock" on:keypress on:click={() => selected (index, item.title)}>
                        <div class="headcbl">
                            <div class="linesbcl {item.line}"></div>
                            <span>{item.price}
                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_1_40)">
                                    <path d="M16.5 8.25C16.5 3.69365 12.8063 0 8.25 0C3.69365 0 0 3.69365 0 8.25C0 12.8063 3.69365 16.5 8.25 16.5C12.8063 16.5 16.5 12.8063 16.5 8.25Z" fill="#CFF80B"/>
                                    <path d="M3.91016 10.5434C3.91016 10.4414 3.97818 10.3904 4.11416 10.3904C4.25013 10.3904 4.67088 10.484 5.37641 10.6709C5.53788 9.27691 5.99268 7.76394 6.74066 6.13194C7.00413 5.53696 7.31868 5.23944 7.68416 5.23944C7.75218 5.23944 7.81593 5.31166 7.87541 5.45619C7.94343 5.60071 7.97741 5.77921 7.97741 5.99169C7.97741 6.24669 7.84143 6.94794 7.56941 8.09544C7.30593 9.24294 7.13163 10.2417 7.04666 11.0917C7.60766 11.2192 8.10063 11.2829 8.52566 11.2829C8.95916 11.2829 9.35441 11.1725 9.71141 10.9514C10.0684 10.7219 10.3744 10.4287 10.6294 10.0717C11.1564 9.31516 11.4199 8.40571 11.4199 7.34319C11.4114 5.37969 10.6294 4.39794 9.07391 4.39794C8.52138 4.40641 7.54391 4.65294 6.14141 5.13744C5.86938 5.23096 5.63141 5.27769 5.42741 5.27769C5.22341 5.27769 5.12141 5.21821 5.12141 5.09919C5.12141 4.93771 5.24043 4.74646 5.47841 4.52544C5.71638 4.30441 6.02238 4.09194 6.39641 3.88794C7.31441 3.39494 8.20691 3.14844 9.07391 3.14844C10.2639 3.14844 11.2414 3.46719 12.0064 4.10469C12.9074 4.86121 13.3536 6.00871 13.3452 7.54719C13.3452 8.20171 13.2432 8.84769 13.0392 9.48519C12.8352 10.1227 12.5249 10.6922 12.1084 11.1937C11.6919 11.6867 11.1649 12.0862 10.5274 12.3922C9.88991 12.6982 9.13766 12.8512 8.27066 12.8512C7.92213 12.8512 7.48016 12.7747 6.94466 12.6217C6.88518 12.7832 6.73638 12.8639 6.49841 12.8639C6.05643 12.8639 5.75463 12.7917 5.59316 12.6472C5.44016 12.4942 5.35091 12.2477 5.32541 11.9077C4.91741 11.6782 4.57743 11.4402 4.30541 11.1937C4.04193 10.9472 3.91016 10.7304 3.91016 10.5434Z" fill="#1E1E1E" fill-opacity="0.5"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_1_40">
                                    <rect width="16.5" height="16.5" fill="white"/>
                                    </clipPath>
                                    </defs>
                                </svg>                                    
                            </span>
                        </div>
                        <img src="{item.img}" onerror="this.onerror=null;this.src=this.src.replace('cdn-world.majestic-files.net/public/master/static/img/vehicles','cdn-ra3.ragemp.pro/cloud/inventoryItems/vehicle')" alt=""/>
                        <p>{item.title}</p>
                    </div>
                {/each}
            </div>
        </div>
    </div>
    {:else}
    <h1 class="shop">Автомобили</h1>
    <div class="list1">
        {#each shopList as item, index}
            {#if (!searchText || !searchText.length) || (searchText && item.title.toLowerCase().trim().includes(searchText.toLowerCase().trim()))}     
                <div class="blockrewrad" on:keypress on:click={() => selected (index, item.title)}>
                    <div class="headrewrad">
                        <div class="line {item.line}"></div>
                        <span>{item.price}
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_951_28)">
                                <g filter="url(#filter0_d_951_28)">
                                <path d="M16.875 10C16.875 6.20304 13.797 3.125 10 3.125C6.20304 3.125 3.125 6.20304 3.125 10C3.125 13.797 6.20304 16.875 10 16.875C13.797 16.875 16.875 13.797 16.875 10Z" fill="#CFF80B"/>
                                </g>
                                <path d="M6.38281 11.9125C6.38281 11.8275 6.4395 11.785 6.55281 11.785C6.66613 11.785 7.01675 11.8629 7.60469 12.0187C7.73925 10.8571 8.11825 9.59625 8.74156 8.23625C8.96113 7.74044 9.22325 7.4925 9.52781 7.4925C9.5845 7.4925 9.63763 7.55269 9.68719 7.67312C9.74388 7.79356 9.77219 7.94231 9.77219 8.11937C9.77219 8.33187 9.65888 8.91625 9.43219 9.8725C9.21263 10.8287 9.06738 11.6611 8.99656 12.3694C9.46406 12.4756 9.87488 12.5287 10.2291 12.5287C10.5903 12.5287 10.9197 12.4367 11.2172 12.2525C11.5147 12.0613 11.7697 11.8169 11.9822 11.5194C12.4214 10.8889 12.6409 10.1311 12.6409 9.24562C12.6339 7.60937 11.9822 6.79125 10.6859 6.79125C10.2255 6.79831 9.41094 7.00375 8.24219 7.4075C8.0155 7.48544 7.81719 7.52437 7.64719 7.52437C7.47719 7.52437 7.39219 7.47481 7.39219 7.37562C7.39219 7.24106 7.49138 7.08169 7.68969 6.8975C7.888 6.71331 8.143 6.53625 8.45469 6.36625C9.21969 5.95542 9.96344 5.75 10.6859 5.75C11.6776 5.75 12.4922 6.01562 13.1297 6.54687C13.8805 7.17731 14.2524 8.13356 14.2453 9.41562C14.2453 9.96106 14.1603 10.4994 13.9903 11.0306C13.8203 11.5619 13.5618 12.0364 13.2147 12.4544C12.8676 12.8652 12.4284 13.1981 11.8972 13.4531C11.3659 13.7081 10.7391 13.8356 10.0166 13.8356C9.72613 13.8356 9.35781 13.7719 8.91156 13.6444C8.862 13.7789 8.738 13.8462 8.53969 13.8462C8.17138 13.8462 7.91988 13.7861 7.78531 13.6656C7.65781 13.5381 7.58344 13.3327 7.56219 13.0494C7.22219 12.8581 6.93888 12.6598 6.71219 12.4544C6.49263 12.2489 6.38281 12.0683 6.38281 11.9125Z" fill="#1E1E1E" fill-opacity="0.5"/>
                                </g>
                                <defs>
                                <filter id="filter0_d_951_28" x="-1.875" y="-1.875" width="23.75" height="23.75" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                <feOffset/>
                                <feGaussianBlur stdDeviation="2.5"/>
                                <feComposite in2="hardAlpha" operator="out"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 0.811765 0 0 0 0 0.972549 0 0 0 0 0.0431373 0 0 0 0.25 0"/>
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_951_28"/>
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_951_28" result="shape"/>
                                </filter>
                                <clipPath id="clip0_951_28">
                                <rect width="20" height="20" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>                            
                        </span>
                    </div>
                    <img class="n" src="{item.img}" onerror="this.onerror=null;this.src=this.src.replace('cdn-world.majestic-files.net/public/master/static/img/vehicles','cdn-ra3.ragemp.pro/cloud/inventoryItems/vehicle')" alt=""/>
                    <p>{item.title}</p>
                </div>
            {/if}
        {/each}
    </div>
{/if}